import type { ThunkDispatch } from '@reduxjs/toolkit';
import { configureStore } from '@reduxjs/toolkit';
import type { AnyAction } from 'redux';
/*-----------------------------------*/
import { aiTextGenerationApi } from '../services/aiTextGenerationApi';
import { businessPlanApi } from '../services/businessPlan';
import { companyApi } from '../services/companyApi';
import { financialPlanApi } from '../services/financialPlanApi';
import { instrumentV2Api } from '../services/instrumentsApi';
import { graphApi } from '../services/graphApi';
import { projectTaskApi } from '../services/projectTasksApi';
import { projectApi } from '../services/projectApi';
import aiAgentApi from '../services/aiAgentApi';
import { promptApi } from '../services/promptApi';
/*-----------------------------------*/
import { name as companySearchName, reducer as companySearchReducer } from '../taskpane/components/companySearch/slice';
import { name as instrumentSearchName, reducer as instrumentSearchReducer } from '../taskpane/components/instrumentSearch/slice';

export const store = configureStore({
	reducer: {
		[companyApi.reducerPath]: companyApi.reducer,
		[aiTextGenerationApi.reducerPath]: aiTextGenerationApi.reducer,
		[companySearchName]: companySearchReducer,
		[instrumentV2Api.reducerPath]: instrumentV2Api.reducer,
		[instrumentSearchName]: instrumentSearchReducer,
		[financialPlanApi.reducerPath]: financialPlanApi.reducer,
		[businessPlanApi.reducerPath]: businessPlanApi.reducer,
		[graphApi.reducerPath]: graphApi.reducer,
		[projectTaskApi.reducerPath]: projectTaskApi.reducer,
		[projectApi.reducerPath]: projectApi.reducer,
		[aiAgentApi.reducerPath]: aiAgentApi.reducer,
		[promptApi.reducerPath]: promptApi.reducer,
	} as any,
	middleware: getDefaultMiddleware =>
		getDefaultMiddleware({
			serializableCheck: false,
			immutableCheck: false,
		}).concat(
			companyApi.middleware,
			aiTextGenerationApi.middleware,
			instrumentV2Api.middleware,
			financialPlanApi.middleware,
			businessPlanApi.middleware,
			graphApi.middleware,
			projectTaskApi.middleware,
			projectApi.middleware,
			aiAgentApi.middleware,
			promptApi.middleware,
		) as any,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction>;
